import React from "react";
import { node, string } from "prop-types";
import { classes } from "../utils/classes";

const BlockQuoteSimple = ({ className = "", children }) => {
	return <blockquote className={classes("blockquote", className)}>{children}</blockquote>;
};

BlockQuoteSimple.propTypes = {
	className: string,
	children: node.isRequired,
};

export default BlockQuoteSimple;
